
import React from 'react';
import { useMsal } from "@azure/msal-react";
import { config } from '../../ApplicationConfig/msal';


export default function SignInButton(props){

    const {instance}=useMsal();
    

    function handleLogin() {


        const accessTokenRequest = {
            scopes: [`api://${config.msal.CLIENT_ID}/Vetting.Access`],
            extraQueryParameters: {
              mkt: 'en',
            },
          };
          instance
            .loginRedirect(accessTokenRequest)
            .catch((error) => {
              if (error.errorCode=="endpoints_resolution_error")
              {
                location.href="/error"
              }

              // Acquire token interactive failure
              // eslint-disable-next-line no-console
              //console.log(error.errorCode);
            })

    }

    React.useEffect(()=>{
      handleLogin();
    },[instance]) 
    return (<></>)
}